import Storage from '@/utils/storage';

const state = {
  sidebar: {
    opened: Storage.get('sidebarStatus') ? !!+Storage.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Storage.get('size') || 'medium',
  env: '',
  loading: 0 // 全局loading计数
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Storage.set('sidebarStatus', 1)
    } else {
      Storage.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Storage.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Storage.set('size', size)
  },
  SET_ENV: (state, env) => {
    state.env = env
  },
  // 增加loading计数
  INCREMENT_LOADING: state => {
    state.loading++
  },
  // 减少loading计数
  DECREMENT_LOADING: state => {
    state.loading = Math.max(0, state.loading - 1)
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
